var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('RAFTFullScreenContent', {
    attrs: {
      "header-text": "Incident Reports"
    }
  }, [_vm.getUpdatingReportsStatus === 'success' ? _c('div', {
    attrs: {
      "id": "table-ready"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "csv-export-link",
      "data-test": "csv-export-link",
      "href": "#"
    },
    on: {
      "click": _vm.incidentReportsPostToCsvDownload
    }
  }, [_c('b-img', {
    attrs: {
      "src": _vm.getCsvIconPath,
      "width": "24",
      "height": "24",
      "fluid": "",
      "alt": "CSV Download"
    }
  })], 1)]), _vm._v(" "), _c('VFilterGroup', {
    staticClass: "incident-report-listing-filters",
    attrs: {
      "show-submit": false,
      "show-clear": false,
      "show-advanced-option": false
    },
    scopedSlots: _vm._u([{
      key: "filters",
      fn: function () {
        return [_c('single-select-filter', {
          attrs: {
            "id": "report-type",
            "label": "Report Type",
            "update-method": _vm.updateReportType,
            "path": "field_incident_report.field_in_report_type_of_report",
            "operator": "=",
            "multiple": false,
            "get-value": _vm.reportTypes,
            "selected-items": [_vm.reportType],
            "disable-empty-selection": false
          }
        }), _vm._v(" "), _vm.allDepartments && _vm.allDepartments.length > 0 ? _c('single-select-filter', {
          attrs: {
            "id": "department-filter",
            "label": "Department/Unit",
            "update-method": _vm.updateDepartment,
            "path": "field_inc_invest_department_unit",
            "operator": "=",
            "multiple": false,
            "get-value": _vm.allDepartments,
            "display-value": "title",
            "track-by": "nid",
            "disable-empty-selection": false
          }
        }) : _vm._e(), _vm._v(" "), _vm.incidentManagementTeamMembers && _vm.incidentManagementTeamMembers.length > 0 ? _c('single-select-filter', {
          attrs: {
            "id": "assigned-to-filter",
            "label": "Assigned To",
            "update-method": _vm.updateAssignedTo,
            "path": "field_inc_invst_team_assigned",
            "operator": "=",
            "multiple": false,
            "get-value": _vm.incidentManagementTeamMembers,
            "disable-empty-selection": false
          }
        }) : _vm._e(), _vm._v(" "), _c('multi-select-filter', {
          attrs: {
            "id": "report-status-filter",
            "label": "Status",
            "update-method": _vm.updateReportStatus,
            "path": "field_inc_invest_report_status_value",
            "get-value": _vm.investigationStatusOptions,
            "disable-empty-selection": false,
            "current-set-value": _vm.reportStatus,
            "track-by": "key",
            "display-value": "label"
          }
        }), _vm._v(" "), _c('date-filter', {
          attrs: {
            "date-between": true,
            "get-value": _vm.reportedAfterDate,
            "update-method": _vm.updateDateBetweenStart,
            "end-date-get-value": _vm.reportedBeforeDate,
            "end-date-update-method": _vm.updateDateBetweenEnd,
            "label": "Reported After",
            "end-label": "Reported Before",
            "id": "date-filter"
          }
        }), _vm._v(" "), _vm.allCampuses && _vm.allCampuses.length > 0 ? _c('single-select-filter', {
          attrs: {
            "get-value": _vm.allCampuses,
            "id": "campus-fil",
            "multiple": false,
            "label": "Site/Campus",
            "display-value": "title",
            "track-by": "nid",
            "disable-empty-selection": false,
            "update-method": _vm.updateSelectedCampus
          }
        }) : _vm._e(), _vm._v(" "), _c('single-select-filter', {
          attrs: {
            "get-value": _vm.filteredBuildings,
            "id": "building-fil",
            "multiple": false,
            "label": "Building",
            "display-value": "title",
            "track-by": "nid",
            "disable-empty-selection": false,
            "update-method": _vm.updateSelectedBuilding
          }
        }), _vm._v(" "), _c('single-select-filter', {
          attrs: {
            "get-value": _vm.buildingSpaces,
            "id": "space-fil",
            "multiple": false,
            "label": "Space/Room",
            "display-value": "title",
            "track-by": "nid",
            "disable": _vm.spaceFilterDisabled,
            "disable-empty-selection": false,
            "update-method": _vm.updateSpace,
            "selected-items": _vm.selectedSpace
          }
        }), _vm._v(" "), _c('single-select-filter', {
          attrs: {
            "get-value": _vm.getGeneralCategoryOptions,
            "id": "gencat-fil",
            "multiple": false,
            "label": "General Category",
            "disable-empty-selection": false,
            "update-method": _vm.updateGeneralCategory,
            "track-by": "value",
            "display-value": "text"
          }
        }), _vm._v(" "), _c('single-select-filter', {
          attrs: {
            "get-value": _vm.getReportableCategoryOptions,
            "id": "repcat-fil",
            "multiple": false,
            "label": "Reportable Category",
            "disable-empty-selection": false,
            "update-method": _vm.updateReportableCategory,
            "track-by": "value",
            "display-value": "text"
          }
        }), _vm._v(" "), _c('single-select-filter', {
          attrs: {
            "get-value": _vm.getAreaTypeOptions,
            "id": "areatype-fil",
            "multiple": false,
            "label": "Area Type",
            "disable-empty-selection": false,
            "update-method": _vm.updateAreaType,
            "track-by": "value",
            "display-value": "text"
          }
        }), _vm._v(" "), _c('multi-select-filter', {
          attrs: {
            "id": "bls-code-filter",
            "label": "BLS Codes",
            "update-method": _vm.updateBlsCodes,
            "path": "field_inc_invest_report_status_value",
            "get-value": _vm.blsCodeList,
            "disable-empty-selection": false,
            "current-set-value": _vm.selectedBlsCodes,
            "track-by": "key",
            "display-value": "label"
          }
        })];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('BaseTable', {
    ref: "table",
    attrs: {
      "items": _vm.items,
      "fields": _vm.fields,
      "total-items": _vm.totalItems,
      "items-per-page": _vm.itemsPerPage,
      "current-page": _vm.currentPage,
      "is-busy": _vm.getUpdatingReportsStatus === 'busy',
      "class-prefix": "incident-reports",
      "no-local-sorting": true
    },
    on: {
      "update-current-page": _vm.updateCurrentPage,
      "sort-changed": _vm.sortingChanged
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function () {
        return [_c('div', {
          staticClass: "empty-text"
        }, [_vm._v("\n        There are currently no incident reports to list.\n      ")])];
      },
      proxy: true
    }, {
      key: "link-cell",
      fn: function (data) {
        var _data$data, _data$data$value;
        return [data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && (_data$data$value = _data$data.value) !== null && _data$data$value !== void 0 && _data$data$value.url ? _c('a', {
          attrs: {
            "href": data.data.value.url
          }
        }, [_vm._v(_vm._s(data.data.value.text))]) : _c('span', [_vm._v(_vm._s(data.data.value.text))])];
      }
    }])
  }), _vm._v(" "), _c('notifications', {
    attrs: {
      "position": "bottom right",
      "group": "alerts"
    }
  }), _vm._v(" "), _c('notifications', {
    attrs: {
      "position": "bottom right",
      "group": "downloads",
      "duration": _vm.downloadProgressNotificationDuration
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }